export default "__VITE_ASSET__DrrV$rdw__"